import { Nullable } from '@clearverify/types';

import { PeoStaffWhere } from 'src/api';
import { getUserFullNameFilter } from 'src/utils/user';

export const prepareSearchStaffsFilter = (searchValue: Nullable<string>): PeoStaffWhere => {
  return searchValue && searchValue.length > 0
    ? {
        user: getUserFullNameFilter(searchValue),
      }
    : {};
};
